import { render } from "./MaterialDetailPage.vue?vue&type=template&id=61b4382d&scoped=true"
import script from "./MaterialDetailPage.vue?vue&type=script&lang=js"
export * from "./MaterialDetailPage.vue?vue&type=script&lang=js"

import "./MaterialDetailPage.vue?vue&type=style&index=0&id=61b4382d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b4382d"]])

export default __exports__